import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import AudioFile from "../components/AudioFile.jsx";

const keyMapping = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "*",
  11: "#",
};

const WhisperAnnouncement = (props) => (
  <SummaryItem itemKey={"Whisper Announcement: "}>
    <SectionItem itemKey={"Audio"}>
      <AudioFile audioId={props.module.audio} />
    </SectionItem>
    <SectionItem itemKey={"Choose To Accept"}>
      {props.module.acceptFlag ? "Yes" : "No"}
    </SectionItem>
    {props.module.acceptFlag && (
      <SectionItem itemKey={"Accept Key"}>
        {keyMapping[props.module.acceptKey]}
      </SectionItem>
    )}
    <SectionItem itemKey={"Choose To Refuse"}>
      {props.module.refuseFlag ? "Yes" : "No"}
    </SectionItem>
    {props.module.refuseFlag && (
      <SectionItem itemKey={"Refuse Key"}>
        {keyMapping[props.module.refuseKey]}
      </SectionItem>
    )}
  </SummaryItem>
);

export default WhisperAnnouncement;

WhisperAnnouncement.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
